module.exports = __webpack_public_path__ + "static/media/CF.da0ec0b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CF.svg
// module id = 2126
// module chunks = 7